export const shareData = {
  title: '吴兴金秋汽车消费券来啦',
  link: 'http://prod-app-frontend.zhijianmedia.cn/front-end-car-ticket/#/share', // 分享链接
  imgUrl:
    'http://prod-app-frontend.zhijianmedia.cn/front-end-car-ticket/img/share.ab106b5d.png',
}
